/**
 * API sözleşmesi — PRD §10 ve §11.
 * Tek dil / tek tip tanımı (ADR-15): sunucu doğrulamada, istemci istek üretiminde
 * aynı şemayı kullanır. Para alanları şema seviyesinde STRING'dir (ADR-03).
 */
import { z } from "zod";
/** numeric(12,2) — "50.00" / "-12.35" */
export const zPara = z
    .string()
    .regex(/^-?\d{1,10}(\.\d{1,2})?$/, 'Para değeri "12345.67" biçiminde string olmalıdır');
/** numeric(12,3) */
export const zMiktar = z
    .string()
    .regex(/^-?\d{1,10}(\.\d{1,3})?$/, 'Miktar değeri "1.500" biçiminde string olmalıdır');
export const zTarihSaat = z.string().datetime({ offset: true });
export const zId = z
    .union([z.string().regex(/^\d+$/), z.number().int().positive()])
    .transform(String);
// ---------------------------------------------------------------------------
// §10.1 Satış oluşturma
// ---------------------------------------------------------------------------
export const zSatisSatiri = z.object({
    urun_id: zId,
    adet: zMiktar,
    birim_fiyat: zPara,
});
export const zSatisIstegi = z.object({
    terminal_id: z.number().int().positive(),
    yerel_seq: z.number().int().nonnegative(),
    kart_uid: z.string().min(1).max(64).nullable().optional(),
    olusma_zamani: zTarihSaat,
    offline_mi: z.boolean().default(false),
    odeme_tipi: z.number().int().min(1).max(3).default(1),
    satirlar: z.array(zSatisSatiri).min(1).max(200),
    toplam: zPara,
    /** Kısmi satışta çıkarılan ürünler — denetim izi için (KK-306) */
    cikarilan_urunler: z.array(zId).optional(),
});
// ---------------------------------------------------------------------------
// §11.2 Delta pull
// ---------------------------------------------------------------------------
export const zSenkronPull = z.object({
    terminal_id: z.number().int().positive(),
    son_surum: z
        .object({
        urun: z.number().int().nonnegative().default(0),
        kisi: z.number().int().nonnegative().default(0),
        kisitlama: z.number().int().nonnegative().default(0),
        personel: z.number().int().nonnegative().default(0),
    })
        .default({ urun: 0, kisi: 0, kisitlama: 0, personel: 0 }),
});
// ---------------------------------------------------------------------------
// KK-409 heartbeat
// ---------------------------------------------------------------------------
export const zHeartbeat = z.object({
    terminal_id: z.number().int().positive(),
    kuyruk_derinligi: z.number().int().nonnegative(),
    son_senkron: zTarihSaat.nullable(),
    uygulama_surumu: z.string().max(40),
    depolama_izni: z.boolean(),
    agent_surumu: z.string().max(40).nullable().optional(),
});
// ---------------------------------------------------------------------------
// M12 kısmı — okul üzerinden yükleme (KK-1207…1215)
// ---------------------------------------------------------------------------
export const zYuklemeBildirimi = z.object({
    kisi_id: zId,
    tutar: zPara,
    havale_tarihi: z.string().date(),
    aciklama: z.string().max(500).optional(),
    /**
     * DEKONTUN ADRESİ DEĞİL, YÜKLENMİŞ DOSYANIN KİMLİĞİ (0015_medya.sql).
     *
     * Eskiden burada `dekont_url` vardı ve veliden dosyasının linkini yazması
     * bekleniyordu. Bu, KK-1215 mutabakatında delil olarak istenen belgenin
     * aslında bizde HİÇ olmaması demekti: link bir sohbet uygulamasının geçici
     * adresiyse birkaç gün sonra ölür. Artık veli dosyayı
     * POST /medya?tur=yukleme_dekont ile yükler ve dönen kimliği buraya koyar.
     */
    dekont_medya_id: zId.nullable().optional(),
});
export const zYuklemeIsleme = z.object({
    kisi_id: zId,
    tutar: zPara,
    /** 2 = nakit (KK-1212), 10 = havale (KK-1210) */
    tip: z.union([z.literal(2), z.literal(10)]),
    bildirim_id: zId.nullable().optional(),
    aciklama: z.string().max(500).optional(),
});
// ---------------------------------------------------------------------------
// Kısıtlama tanımı (veli/okul)
// ---------------------------------------------------------------------------
export const zKisitTanimi = z.object({
    kisi_id: zId,
    tip: z.number().int().min(1).max(5),
    urun_id: zId.nullable().optional(),
    kategori_id: zId.nullable().optional(),
    alerjen: z.string().max(64).nullable().optional(),
    deger: zPara.nullable().optional(),
    aktif: z.boolean().default(true),
});
// ---------------------------------------------------------------------------
// Stok / transfer
// ---------------------------------------------------------------------------
export const zTransferOlustur = z.object({
    kaynak_nokta_id: zId,
    hedef_nokta_id: zId,
    sebep: z.number().int().min(1).max(5),
    aciklama: z.string().max(500).optional(),
    satirlar: z
        .array(z.object({ urun_id: zId, gonderilen_miktar: zMiktar }))
        .min(1),
});
export const zTransferTeslim = z.object({
    satirlar: z
        .array(z.object({ urun_id: zId, teslim_alinan_miktar: zMiktar }))
        .min(1),
    aciklama: z.string().max(500).optional(),
});
//# sourceMappingURL=sozlesme.js.map